'use strict';

var React = require('react');

var SvgFraudProtectMinor = function SvgFraudProtectMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.822 12.683c-1.349 2.513-3.885 4.485-6.818 5.317-2.935-.832-5.471-2.804-6.82-5.317-1.42-2.645-1.184-5.683-.184-8.683 1.361-.089 3.983-.573 7.004-2 3.02 1.427 5.635 1.911 6.996 2 1 3 1 6-.178 8.683zm-2.615-5.89a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2.5-2.5a1 1 0 1 1 1.414-1.414l1.793 1.793 3.793-3.793a1 1 0 0 1 1.414 0z"
  }));
};

exports.SvgFraudProtectMinor = SvgFraudProtectMinor;
